import { Archivo, IArchivo } from "./archivo.model";

export interface IEmpresa {
  idEmpresa: string;
  razonSocial: string;
  nombreComercial: string;
  logo?: IArchivo;
}

export class Empresa {
  idEmpresa: string;
  razonSocial: string;
  nombreComercial: string;
  logo?: Archivo;

  constructor(data: IEmpresa) {
    this.idEmpresa = data.idEmpresa;
    this.razonSocial = data.razonSocial;
    this.nombreComercial = data.nombreComercial;
    this.logo = data.logo 
      ? new Archivo(data.logo) 
      : undefined;
  }
}
